import { Outlet } from 'react-router-dom';
import { PortalHeader } from './PortalHeader';
import { PortalSidebar } from './PortalSidebar';

/**
 * Patient-portal shell (issue #154): ACTO chrome — fixed patient sidebar + top
 * bar + scrolling content. Rendered as the element of the `RequirePatientAuth`
 * route group; feature pages land in the <Outlet />.
 */
export function PortalLayout() {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-background text-foreground">
      <PortalSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <PortalHeader />
        <main className="flex-1 overflow-y-auto p-3 md:p-6" data-testid="portal-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default PortalLayout;
